/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory, withRouter } from 'react-router-dom'
import { getCreateEventData, getUserInfo, removeCreateEventData } from '_utils/localData'

import { getListPackingList } from '_redux/modules/event'

import useBlockFeatureCheck from '_hooks/useBlockFeatureCheck'
import './style.scss'

const Footer = ({ location }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [pathname, setPathname] = useState(location.pathname.split('/'))
  const { myEvents, listPackingList } = useSelector((state) => state.event)
  const currentUser = getUserInfo()
  const isAllowHost =
    currentUser?.groups?.length && currentUser?.groups?.some((g) => g?.isHost || g?.isAdmin)
  const { checkAndProceed, BlockPopup } = useBlockFeatureCheck()

  const checkHighLight = () => {
    const paths = [
      'create',
      'create-items',
      'created-confirm',
      'update',
      'update-items',
      'update-confirm',
      'hosting',
    ]
    if (pathname[1] === 'event' && paths.includes(pathname[2].split('?')[0])) {
      return true
    }
    return false
  }

  const handleOnClickToCreateEvent = async () => {
    checkAndProceed(() => {
      const eventData = getCreateEventData()
      if (eventData?.id) {
        removeCreateEventData()
      }
      history.push('/event/hosting')
    })
  }

  useEffect(() => {
    const getPackingList = async () => {
      await dispatch(getListPackingList)
    }
    getPackingList()
  }, [])

  useEffect(() => {
    setPathname(location.pathname.split('/'))
  }, [location])

  return (
    <React.Fragment>
      {isAllowHost && (
        <footer className='footer footer-admin'>
          <div className='container'>
            <ul className='menu'>
              <li>
                <a
                  className={`${checkHighLight() ? 'active' : ''} cursor-pointer`}
                  onClick={handleOnClickToCreateEvent}
                >
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='1.8'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <line x1='12' y1='5' x2='12' y2='19' />
                    <line x1='5' y1='12' x2='19' y2='12' />
                  </svg>
                  <span>New Event</span>
                </a>
              </li>
              <li>
                <Link
                  to='/event/list-my-events'
                  className={
                    pathname[1] === 'event' && pathname[2] === 'list-my-events' ? 'active' : ''
                  }
                >
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='1.8'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <rect x='3' y='4' width='18' height='18' rx='2' />
                    <line x1='16' y1='2' x2='16' y2='6' />
                    <line x1='8' y1='2' x2='8' y2='6' />
                    <line x1='3' y1='10' x2='21' y2='10' />
                  </svg>
                  <span>
                    Hosted Event{' '}
                    {Boolean(myEvents?.length) && (
                      <span className='badge-count'>({myEvents?.length})</span>
                    )}
                  </span>
                </Link>
              </li>

              {currentUser?.isUsingFeature && listPackingList?.length ? (
                <li>
                  <Link
                    to='/event/list-packing-list'
                    className={
                      pathname[1] === 'event' && ['packing-list', 'list-packing-list'].includes(pathname[2]) ? 'active' : ''
                    }
                  >
                    <svg
                      width='20'
                      height='20'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='1.8'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <line x1='16.5' y1='9.4' x2='7.5' y2='4.21' />
                      <path d='M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' />
                      <polyline points='3.27 6.96 12 12.01 20.73 6.96' />
                      <line x1='12' y1='22.08' x2='12' y2='12' />
                    </svg>
                    <span>
                      Packages{' '}
                      {Boolean(listPackingList?.length) && (
                        <span className='badge-count'>({listPackingList?.length})</span>
                      )}
                    </span>
                  </Link>
                </li>
              ) : (
                ''
              )}
            </ul>
          </div>
        </footer>
      )}
      {BlockPopup}
    </React.Fragment>
  )
}

export default withRouter(Footer)
